import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { injectIntl } from 'react-intl';
import { grey500 } from 'material-ui/styles/colors';
import Divider from 'material-ui/Divider';
import {
  Card,
  CardHeader,
  CardText,
} from 'material-ui/Card';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Radium from 'radium';
import ReportListItem from './components/ReportListItem';
import CreateReportDialog from './components/CreateReportDialog';
import _ from 'lodash';

const styles = {
  reportListWrapper: {
    margin: '0 -10px 100px',
  },
  reportWrapper: {
    width: '33.333%',
    display: 'inline-block',
    padding: 10,
    boxSizing: 'border-box',
    verticalAlign: 'top',
  },
  dividerWrapper: {
    padding: 10,
  },
  folderWrapper: {
    padding: 10,
  },
  folderTitle: {
    fontSize: 18,
    marginBottom: 5,
  },
  folderSubtitle: {
    color: grey500,
    fontWeight: 'normal',
    fontSize: 13,
  },
  addReportButton: {
    position: 'fixed',
    bottom: 30,
    right: 30,
  },
};

@injectIntl
@Radium
class ReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addReportDialogOpen: false,
    };
  }

  showAddReportDialog = () => {
    this.setState({ addReportDialogOpen: true });
  };

  hideAddReportDialog = () => {
    this.setState({ addReportDialogOpen: false });
  };

  render() {
    const isAccountAdmin = (this.props.query.viewer.roles || []).includes('account_admin');

    const reportNodes = this.props.query.reports.edges.map(edge => edge.node);
    const viewerDevices = this.props.query.viewer.devices;
    const viewerReports = this.props.query.viewer.reports;

    const visibleReports = reportNodes.filter((report) => {
      if (
        viewerReports &&
        viewerReports.length > 0 &&
        !_.includes(_.map(viewerReports, 'id'), report.id)
      ) {
        return false;
      } else if (
        viewerDevices &&
        viewerDevices.length > 0 &&
        report.devices &&
        report.devices.length > 0
      ) {
        const deviceArrays = [
          viewerDevices,
          report.devices,
        ].filter(arr => arr && arr.length > 0);
        return _.intersectionBy(...deviceArrays, 'id').length > 0;
      } else {
        return true;
      }
    });

    const reportsWithoutFolder = visibleReports.filter(r => !r.folder);

    const folders = _(visibleReports)
      .filter(r => r.folder)
      .groupBy('folder')
      .toPairs()
      .map(([folder, reports]) => ({ name: folder, reports }))
      .sortBy('name')
      .value();

    return (
      <div>
        <div style={styles.reportListWrapper}>
          {reportsWithoutFolder.map(report =>
            <div
              key={report.id}
              style={styles.reportWrapper}
            >
              <ReportListItem report={report} isAccountAdmin={isAccountAdmin} />
            </div>
          )}
          {reportsWithoutFolder.length > 0 && folders.length > 0 && (
            <div style={styles.dividerWrapper}>
              <Divider />
            </div>
          )}
          {folders.map(folder =>
            <div
              key={folder.name}
              style={styles.folderWrapper}
            >
              <Card>
                <CardHeader
                  title={folder.name}
                  subtitle={this.props.intl.formatMessage(
                    { id: 'numberOfReports' },
                    { count: folder.reports.length }
                  )}
                  titleStyle={styles.folderTitle}
                  subtitleStyle={styles.folderSubtitle}
                  actAsExpander={true}
                  showExpandableButton={true}
                />
                <CardText expandable={true}>
                  {folder.reports.map(report =>
                    <div
                      key={report.id}
                      style={styles.reportWrapper}
                    >
                      <ReportListItem report={report} isAccountAdmin={isAccountAdmin} />
                    </div>
                  )}
                </CardText>
              </Card>
            </div>
          )}
        </div>
        {isAccountAdmin && (
          <div>
            <FloatingActionButton
              onTouchTap={this.showAddReportDialog}
              style={styles.addReportButton}
            >
              <ContentAdd />
            </FloatingActionButton>
            <CreateReportDialog
              open={this.state.addReportDialogOpen}
              onClose={this.hideAddReportDialog}
            />
          </div>
        )}
      </div>
    )
  }
}

export default createFragmentContainer(
  ReportList,
  graphql`
    fragment ReportList_query on Query {
      viewer {
        roles
        devices {
          id
        }
        reports {
          id
        }
      }
      reports(
        first: 2147483647 # max GraphQLInt
      ) @connection(key: "ReportList_reports") {
        edges {
          node {
            id
            folder
            devices {
              id
            }
            ...ReportListItem_report
          }
        }
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Reports/components/ReportList/ReportList.js